import { Close } from '@radix-ui/react-dialog';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { useMedia } from 'react-use';

import { SankeyLegend } from '@/components/SankeyDiagram/SankeyLegend';
import { SankeyTooltip } from '@/components/SankeyDiagram/SankeyTooltip';
import { SubRoute } from '@/components/SankeyDiagram/types';

import { useMeasure } from '@/hooks/useMeasure';

import { dialogCloseBtnStyles } from '@/styles/dialog';
import { fontStyles } from '@/styles/typography';
import { breakpoints } from '@/styles/util';

import { XIcon } from '@/ui/Icons/XIcon';
import { Modal } from '@/ui/Modal';

import { Route } from '@/utils/0x.types';

const SankeyDiagram = dynamic(
  () => import('../../SankeyDiagram').then((mod) => mod.SankeyDiagram),
  { ssr: false },
);

interface SankeyModalProps {
  route: Route;
  chainId: number;
  isOpen: boolean;
  onClose: () => void;
}

const aspectRatio = 10 / 19;

export const SankeyModal = ({ route, chainId, isOpen, onClose }: SankeyModalProps) => {
  const [subRoute, onSubRouteTouch] = useState<SubRoute | undefined>(undefined);
  const isMobile = useMedia(breakpoints.mobile, false);
  const {
    bounds: { width },
    nodeRef,
  } = useMeasure<HTMLDivElement>();
  return (
    <Modal isOpen={isOpen} onClose={onClose} onOpenChange={onClose} variant="XLARGE">
      <div className="py-5 px-6 pb-9" ref={nodeRef}>
        <div className="mb-9">
          <h5 className={fontStyles({ variant: 'H5', class: 'mb-5' })}>Route</h5>
          <Close
            className={dialogCloseBtnStyles().button({
              absolute: true,
            })}
          >
            <XIcon aria-hidden className={dialogCloseBtnStyles().icon()} />
          </Close>
          <SankeyDiagram
            isMobile={isMobile}
            onSubRouteTouch={onSubRouteTouch}
            route={route}
            width={width}
            height={aspectRatio * width}
            chainId={chainId}
          />
        </div>
        {subRoute && isMobile ? <SankeyTooltip {...subRoute} /> : <SankeyLegend route={route} />}
      </div>
    </Modal>
  );
};
